import { render, staticRenderFns } from "./modalEditOrderBusinessWall.vue?vue&type=template&id=11466c2c&"
import script from "./modalEditOrderBusinessWall.vue?vue&type=script&lang=js&"
export * from "./modalEditOrderBusinessWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports